import SepoliaStBTC from "@acre-btc/contracts/deployments/sepolia/stBTC.json";
import MainnetStBTC from "@acre-btc/contracts/deployments/mainnet/stBTC.json";
import { EthersContractWrapper, } from "./contract";
import { Hex } from "../utils";
class EthereumStBTC
// @ts-expect-error TODO: Figure out why type generated by typechain does not
// satisfy the constraint `Contract`. Error: `Property '[internal]' is missing
// in type 'StBTC' but required in type 'BaseContract'`.
 extends EthersContractWrapper {
    #BASIS_POINT_SCALE = BigInt(1e4);
    #cache = { entryFeeBasisPoints: undefined, exitFeeBasisPoints: undefined };
    constructor(config, network) {
        let artifact;
        switch (network) {
            case "sepolia":
                artifact = SepoliaStBTC;
                break;
            case "mainnet":
                artifact = MainnetStBTC;
                break;
            default:
                throw new Error("Unsupported network");
        }
        super(config, artifact);
    }
    /**
     * @see {StBTC#getChainIdentifier}
     */
    getChainIdentifier() {
        return this.getAddress();
    }
    /**
     * @see {StBTC#totalAssets}
     */
    totalAssets() {
        return this.instance.totalAssets();
    }
    /**
     * @see {StBTC#balanceOf}
     */
    balanceOf(identifier) {
        return this.instance.balanceOf(`0x${identifier.identifierHex}`);
    }
    /**
     * @see {StBTC#assetsBalanceOf}
     */
    assetsBalanceOf(identifier) {
        return this.instance.assetsBalanceOf(`0x${identifier.identifierHex}`);
    }
    /**
     * @see {StBTC#calculateDepositFee}
     */
    async calculateDepositFee(amount) {
        const entryFeeBasisPoints = await this.#getEntryFeeBasisPoints();
        return this.#feeOnTotal(amount, entryFeeBasisPoints);
    }
    /**
     * @see {StBTC#calculateDepositFee}
     */
    async calculateWithdrawalFee(amount) {
        const exitFeeBasisPoints = await this.#getExitFeeBasisPoints();
        return this.#feeOnTotal(amount, exitFeeBasisPoints);
    }
    async #getEntryFeeBasisPoints() {
        if (this.#cache.entryFeeBasisPoints) {
            return this.#cache.entryFeeBasisPoints;
        }
        this.#cache.entryFeeBasisPoints = await this.instance.entryFeeBasisPoints();
        return this.#cache.entryFeeBasisPoints;
    }
    async #getExitFeeBasisPoints() {
        if (this.#cache.exitFeeBasisPoints) {
            return this.#cache.exitFeeBasisPoints;
        }
        this.#cache.exitFeeBasisPoints = await this.instance.exitFeeBasisPoints();
        return this.#cache.exitFeeBasisPoints;
    }
    /**
     * @see {StBTC#encodeApproveAndCallFunctionData}
     */
    encodeApproveAndCallFunctionData(spender, shares, extraData) {
        const data = this.instance.interface.encodeFunctionData("approveAndCall", [
            `0x${spender.identifierHex}`,
            shares,
            extraData.toPrefixedString(),
        ]);
        return Hex.from(data);
    }
    /**
     * @see {StBTC#previewRedeem}
     */
    previewRedeem(shares) {
        return this.instance.previewRedeem(shares);
    }
    /**
     * @see {StBTC#convertToShares}
     */
    convertToShares(amount) {
        return this.instance.convertToShares(amount);
    }
    /**
     * Calculates the fee when it's included in the amount.
     * One is added to the result if there is a remainder to match the stBTC
     * contract calculations rounding.
     * @param amount Amount in tBTC
     * @param feeBasisPoints Fee basis points applied to calculate the fee.
     * @returns The fee part of an amount that already includes fees.
     */
    #feeOnTotal(amount, feeBasisPoints) {
        const result = (amount * feeBasisPoints) / (feeBasisPoints + this.#BASIS_POINT_SCALE);
        if ((amount * feeBasisPoints) % (feeBasisPoints + this.#BASIS_POINT_SCALE) >
            0) {
            return result + 1n;
        }
        return result;
    }
}
// eslint-disable-next-line import/prefer-default-export
export { EthereumStBTC };
//# sourceMappingURL=stbtc.js.map